import {
  Component,
  ViewChild,
  OnDestroy,
  AfterViewInit,
  inject,
  ChangeDetectionStrategy
} from '@angular/core';
import { CdkPortalOutlet, Portal, ComponentPortal } from '@angular/cdk/portal';
import { Subscription } from 'rxjs';
import { SideMenusService } from '../side-menus.service';

import { BasketMenuComponent } from '../basket-menu/basket-menu.component';

@Component({
  selector: 'app-dynamic-menu',
  templateUrl: './dynamic-menu.component.html',
  styleUrls: ['./dynamic-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CdkPortalOutlet],
})
export class DynamicMenuComponent implements AfterViewInit, OnDestroy {
  private sideMenusService = inject(SideMenusService);

  @ViewChild(CdkPortalOutlet) dynamicMenuPortalOutlet: CdkPortalOutlet;

  dynamicMenuPortal: Portal<unknown>;

  basketComponentPortal: ComponentPortal<BasketMenuComponent>;
  // someComponentPortal: ComponentPortal<SomeComponent>;

  // Subscription to the Dynamic Menu Portals (content) loading/rendering
  dynamicMenuContentSubscription: Subscription;

  ngOnDestroy() {
    this.dynamicMenuContentSubscription.unsubscribe();
  }

  ngAfterViewInit(): void {
    this.dynamicMenuContentSubscription = this.sideMenusService.renderAltMenuSubject.subscribe(
      (event) => {
        switch (event) {
          // case 'some-menu':
          //   if (!this.someComponentPortal) {
          //     this.someComponentPortal = new ComponentPortal(SomeComponent);
          //   }

          case 'basket':
            if (!this.basketComponentPortal) {
              this.basketComponentPortal = new ComponentPortal(BasketMenuComponent);
            }

            this.dynamicMenuPortal = this.basketComponentPortal;
            break;
          default:
          // Do nothing or render an error component?
        }
      },
      (error) => {
        console.log('renderAltMenu [DynamicMenuComponent] - error', error);
      },
    );
  }
}
